// SPDX-License-Identifier: AGPL-3.0-or-later
import AssistantActivity from '@app/features/konvo_assistant/state/AssistantActivity';
import {ChannelMessages} from '@app/features/messaging/state/ChannelMessages';
import Messages from '@app/features/messaging/state/MessagingMessages';
import TypingIndicator from '@app/features/typing/state/TypingIndicator';
import {KONVOBOT_ID} from '@konvo/constants/src/AppConstants';
import {MessageStates} from '@konvo/constants/src/ChannelConstants';

/** A short optimistic bridge until the server's repeating typing heartbeat arrives. */
export function isAssistantThinking(channelId: string | null, now: number): boolean {
	if (!channelId) return false;
	// A streamed reply is already on screen but still growing; keep the indicator (and its Stop) up.
	if (AssistantActivity.running) return true;
	if (TypingIndicator.isTyping(channelId, KONVOBOT_ID)) return true;
	void Messages.version;
	const latest = ChannelMessages.get(channelId)?.toArray().at(-1);
	return (
		!!latest &&
		latest.author.id !== KONVOBOT_ID &&
		latest.state !== MessageStates.FAILED &&
		now - latest.timestamp.getTime() < 15_000
	);
}
